import RestUtilities from "./Base";
import { LP as LPType } from "../lpLoader/LPContext";

export default class LP {
  static getList() {
    return RestUtilities.get("/api/account/lp/list/").then((response) => {
      return response;
    });
  }

  static GetFromSession(): LPType | null {
    const currLP = sessionStorage.getItem('currentLP');
    let parsed: LPType | null = null;

    if (currLP) {
      parsed = JSON.parse(currLP);
    }


    return parsed;
  }

  static SetInSession(currVal: LPType): void {
    sessionStorage.setItem('currentLP', JSON.stringify(currVal));
  }
}
